import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import React from 'react';
import { rem } from 'polished';
import Icon from '../Icon';

const StepBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: ${rem(35)};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : '')};
`;

const StepTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-size: ${rem(14)};
  margin-top: ${rem(15)};
  width: ${rem(75)};
  height: ${rem(12)};
  color: ${({ color }) => color};
  @media (max-width: ${rem(800)}) {
    width: ${rem(65)};
    font-size: ${rem(12)};
  }
  @media (max-width: ${rem(350)}) {
    width: auto;
    font-size: ${rem(9)};
  }
`;

const Circle = styled.div`
  width: ${rem(20)};
  height: ${rem(20)};
  border: ${rem(2)} solid ${({ color }) => color};
  border-radius: ${rem(50)};
`;

const IconCircle = styled.circle`
  width: ${rem(20)};
  height: ${rem(20)};
  background: ${({ theme }) => theme.color.white};
  align-items: center;
  padding-right: ${rem(4)};
  -moz-border-radius: ${rem(50)};
  -webkit-border-radius: ${rem(50)};
  border-radius: ${rem(50)};
  padding-left: ${rem(4)};
`;

export const Step = props => {
  const { theme, title, type, onClick } = props;

  let color = '';
  let clickable = false;

  if (type === 'checked') {
    color = theme.color.white;
    clickable = true;
  } else if (type === 'next') {
    color = theme.color.disable;
  } else if (type === 'actual') {
    color = theme.color.white;
  }

  return (
    <StepBox
      onClick={clickable ? e => onClick(e) : () => {}}
      clickable={clickable}
    >
      {type === 'checked' ? (
        <IconCircle>
          <Icon name="checkedStep" color={theme.color.font.primary} />
        </IconCircle>
      ) : (
        <Circle color={color} />
      )}

      <StepTitle color={color}>{title}</StepTitle>
    </StepBox>
  );
};

Step.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.shape({
    color: PropTypes.shape({}).isRequired,
  }).isRequired,
  onClick: PropTypes.func,
};
Step.defaultProps = {
  title: '',
  type: '',
  onClick: () => {},
};

export default withTheme(Step);



// WEBPACK FOOTER //
// ./src/components/Step/index.js